module.exports = __webpack_public_path__ + "static/media/bank-ac.9a40c034.png";